import { Guid } from "guid-typescript";

import { IValidationIssue } from "infrastructure/validation";

import { ITermTranslationRow, ITermTranslationModifyData, ITermTranslationErrorModel, ValidationTags } from "./TranslationsManager.state";

const normalizeTranslation = (value?: string) => {
  if (!value) {
    return undefined;
  }

  const normalized = value.trim();
  if (normalized === "") {
    return undefined;
  }

  return normalized;
};

export const getTranslationModifyData = (row: ITermTranslationRow, validationIssues: IValidationIssue[], translation?: string, translationDefinition?: string) => {
  let originalData = row.originalData;
  if (!originalData) {
    originalData = { ...row.data };
  }

  const data: ITermTranslationModifyData = {
    index: row.index,
    isTranslationChanged: row.isTranslationChanged,
    isTranslationDefinitionChanged: row.isTranslationDefinitionChanged,
    translationId: row.data.translationId || Guid.raw(),
    originalData: originalData,
    translation: normalizeTranslation(translation),
    translationDefinition: normalizeTranslation(translationDefinition),
    validationIssues: validationIssues
  };

  if (originalData) {
    if (originalData.translation === data.translation || (!originalData.translation && !data.translation)) {
      data.isTranslationChanged = false;
    } else {
      data.isTranslationChanged = true;
    }

    if (originalData.translationDefinition === data.translationDefinition || (!originalData.translationDefinition && !data.translationDefinition)) {
      data.isTranslationDefinitionChanged = false;
    } else {
      data.isTranslationDefinitionChanged = true;
    }
  }

  return data;
};

export const getValidationTag = (model: ITermTranslationErrorModel) => {
  switch (model.error.property) {
    case "Translation":
      return ValidationTags.Translation;
    case "Definition":
      return ValidationTags.Description;
    default:
      return ValidationTags.Both;
  }
};
